import React, { useEffect } from "react";
import { useCalculatorStoredValue } from "../contexts/CalculatorPersistenceContext";
import { useGradeActions } from "../contexts/GradesContext";
import { useFlowActions } from "../features/calculator/contexts/FlowActionsContext";
import FlowMarkInput from "../features/calculator/components/FlowMarkInput";
import FlowGradeBubble from "../features/calculator/components/FlowGradeBubble";
import { flowGradeColour } from "../features/calculator/constants/flowPresentation";

function GroupSeven() {
  const { updateCoreData } = useGradeActions();

  const [tokEssay, setTokEssay] = useCalculatorStoredValue("core.tokEssay", "");
  const [tokExhibition, setTokExhibition] = useCalculatorStoredValue("core.tokExhibition", "");
  const [eeScore, setEeScore] = useCalculatorStoredValue("core.eeScore", "");

  /* ── TOK grade ── */
  let tokGrade = null;
  if (tokEssay !== "" && tokExhibition !== "") {
    const total = (Number(tokEssay) / 10) * 67 + (Number(tokExhibition) / 10) * 33;
    if      (total >= 73.3) tokGrade = "A";
    else if (total >= 53.3) tokGrade = "B";
    else if (total >= 33.3) tokGrade = "C";
    else if (total >= 13.3) tokGrade = "D";
    else                    tokGrade = "E";
  }

  /* ── EE grade ── */
  let eeGrade = null;
  if (eeScore !== "") {
    const s = Number(eeScore);
    if      (s >= 27) eeGrade = "A";
    else if (s >= 21) eeGrade = "B";
    else if (s >= 14) eeGrade = "C";
    else if (s >= 7)  eeGrade = "D";
    else              eeGrade = "E";
  }

  /* ── core points matrix ── */
  let corePoints = null;
  if (tokGrade && eeGrade) {
    if (tokGrade === "E" || eeGrade === "E") {
      corePoints = 0;
    } else if (
      (tokGrade === "A" && (eeGrade === "A" || eeGrade === "B")) ||
      (tokGrade === "B" &&  eeGrade === "A")
    ) {
      corePoints = 3;
    } else if (
      (tokGrade === "A" && eeGrade === "C") ||
      (tokGrade === "C" && eeGrade === "A") ||
      (tokGrade === "B" && (eeGrade === "B" || eeGrade === "C")) ||
      (tokGrade === "C" &&  eeGrade === "B")
    ) {
      corePoints = 2;
    } else if (
      (tokGrade === "A" && eeGrade === "D") ||
      (tokGrade === "D" && eeGrade === "A") ||
      (tokGrade === "B" && eeGrade === "D") ||
      (tokGrade === "D" && eeGrade === "B") ||
      (tokGrade === "C" && (eeGrade === "C" || eeGrade === "D")) ||
      (tokGrade === "D" &&  eeGrade === "C")
    ) {
      corePoints = 1;
    } else {
      corePoints = 0; // D + D
    }
  }

  useEffect(() => {
    if (corePoints !== null && tokGrade && eeGrade) {
      updateCoreData(corePoints, tokGrade, eeGrade);
    } else {
      updateCoreData(null, null, null);
    }
  }, [corePoints, tokGrade, eeGrade, updateCoreData]);


  const actions = useFlowActions();
  useEffect(() => actions?.register("core", {
    ready: true,
    example: () => { setTokEssay("8"); setTokExhibition("7"); setEeScore("26"); },
    clear: () => { setTokEssay(""); setTokExhibition(""); setEeScore(""); },
  }), [actions, setTokEssay, setTokExhibition, setEeScore]);
  const letterValue = { A: 7, B: 6, C: 4, D: 2, E: 1 };
  return (
    <section className="core-section" aria-labelledby="core-title">
      <div className="core-copy"><h2 id="core-title">TOK and Extended Essay</h2><p>Their two grades combine for up to 3 extra diploma points.</p></div>
      <div className="core-line"><h3>Theory of Knowledge</h3><div className="core-fields">
        <FlowMarkInput label="Essay" weight="67%" pointsPerMark={6.7} impactTarget="TOK total" max={10} value={tokEssay} onChange={setTokEssay} ariaLabel="TOK essay marks" />
        <FlowMarkInput label="Exhibition" weight="33%" pointsPerMark={3.3} impactTarget="TOK total" max={10} value={tokExhibition} onChange={setTokExhibition} ariaLabel="TOK exhibition marks" />
      </div><div className="core-result"><FlowGradeBubble value={tokGrade} progress={tokGrade ? 100 : 0} colour={flowGradeColour(tokGrade ? letterValue[tokGrade] : null)} /><span>TOK grade</span></div></div>
      <div className="core-line"><h3>Extended Essay</h3><div className="core-fields"><FlowMarkInput label="Essay" max={34} value={eeScore} onChange={setEeScore} ariaLabel="Extended Essay marks" /></div><div className="core-result"><FlowGradeBubble value={eeGrade} progress={eeGrade ? 100 : 0} colour={flowGradeColour(eeGrade ? letterValue[eeGrade] : null)} /><span>EE grade</span></div></div>
      <div className="core-line core-points-line"><h3>Core points</h3><div className="core-points-details"><div className="core-points-track" aria-hidden="true"><span style={{ width: `${(corePoints ?? 0) / 3 * 100}%`, background: flowGradeColour(corePoints == null ? null : corePoints / 3 * 7) }} /></div>{(tokGrade === "E" || eeGrade === "E") && <p>Failing condition: E in TOK or EE</p>}</div><div className="core-result" aria-label="Overall core points"><FlowGradeBubble value={corePoints} progress={(corePoints ?? 0) / 3 * 100} colour={flowGradeColour(corePoints == null ? null : corePoints / 3 * 7)} outOf={3} /></div></div>
    </section>
  );
}

export default React.memo(GroupSeven);
